export default __webpack_public_path__ + "static/media/gallery_03.2240be85.jpg";